import { render } from "./404.vue?vue&type=template&id=004237e0"
const script = {}
script.render = render

export default script